import axios from '../axios';

export default {
  getAgents () {
    return new Promise((resolve, reject) => {
      axios.get('/agent')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getAgent (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/agent/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newAgent (agent) {
    return new Promise((resolve, reject) => {
      axios.post('/agent', agent)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateAgent (id, agent) {
    return new Promise((resolve, reject) => {
      axios.put(`/agent/${id}`, agent)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  deleteAgent (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/agent/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newAgentPassword ({ id, password, password_confirmation }) {
    return new Promise((resolve, reject) => {
      axios.post(`/agent/${id}/password`, {
        password,
        password_confirmation,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
